import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DomainJoinDialogComponent } from './domain-join-dialog.component';

@NgModule({
  declarations: [DomainJoinDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule],
  exports: [DomainJoinDialogComponent],
  entryComponents: [DomainJoinDialogComponent],
})
export class DomainJoinDialogModule {}
